import React, {useEffect, useMemo, useState} from 'react'
import {actions as authActions} from '../../redux/modules/auth'
import {useDispatch, useSelector} from 'react-redux'
import {Avatar, Box, Button, Container, TextField, Typography} from '@mui/material'
import styles from './styles'
import {RootState} from 'redux/rootReducer'
import AlertMessage from '../../components/AlertMessage'

const LoginScreen: React.FC = () => {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const dispatch = useDispatch()
  const loginError = useSelector(({auth}: RootState) => auth.error)

  const errorMessage = useMemo(() => {
    if (loginError) {
      return loginError
    }

    return undefined
  }, [loginError])

  const login = () => {
    dispatch(authActions.login({email, password}))
  }

  return (
    <Container component="main" sx={styles.root}>
      <Avatar sx={styles.logo} variant="square" src="logo.png" />
      <Box sx={styles.form} textAlign="center">
        <AlertMessage error={errorMessage} severity="error" sx={{marginBottom: 2, width: 300}} />

        <TextField
          sx={styles.textField}
          onChange={e => setEmail(e.target.value)}
          placeholder="Email"
          onKeyDown={args => args.key === 'Enter' && login()}
        />
        <TextField
          sx={styles.textField}
          type="password"
          onChange={e => setPassword(e.target.value)}
          placeholder="Password"
          onKeyDown={args => args.key === 'Enter' && login()}
        />
        <Button variant="contained" sx={styles.loginButton} onClick={login}>
          Login
        </Button>
      </Box>
    </Container>
  )
}
export default LoginScreen
